import { createSlice } from '@reduxjs/toolkit';
import { MetaType } from 'types';
import { HealthCenterType } from 'types/healthcenterManagement';

interface HealthCenterState {
  healthCenter: HealthCenterType[];
  meta: MetaType;
  healthCenterDetail: HealthCenterType;
}

const initialState: HealthCenterState = {
  healthCenter: [],
  meta: <MetaType>{},
  healthCenterDetail: {} as HealthCenterType
};

const healthCenterSlice = createSlice({
  name: 'healthCenterSlice',
  initialState,
  reducers: {
    setAllHealthCenter(state, action) {
      state.healthCenter = action.payload.results || [];
      state.meta = action.payload.meta || <MetaType>{};
    },
    setOneHealthCenter(state, action) {
      state.healthCenterDetail = action.payload.row;
    },
    addOneHealthCenter(state, action) {
      state.healthCenter = [...state.healthCenter, action.payload.row];
    },
    updateOneHealthCenter(state, action) {
      state.healthCenter = state.healthCenter.map(item => {
        if (item.id !== action.payload.id) return item;
        else return { ...item, ...action.payload.row };
      });
    },
    removeOneHealthCenter(state, action) {
      state.healthCenter = state.healthCenter.filter(
        item => item.id !== action.payload.id
      );
    }
  }
});

export const {
  setAllHealthCenter,
  setOneHealthCenter,
  addOneHealthCenter,
  updateOneHealthCenter,
  removeOneHealthCenter
} = healthCenterSlice.actions;
export default healthCenterSlice.reducer;
